import { useState } from 'react';

const Input = (props) => {
    const {
        name,
        id,
        disabled,
        type,
        className = '',
        onChange,
        onPress,
        value,
        rawValue,
        fontSize = '',
        placeholder,
        readOnly,
        maxLength,
        onKeyUp,
        onBlur,
        onFocus,
        onClick,
        autoComplete = 'off',
        style,
        'data-rum-ignore': dataRumIgnore,
    } = props;

    const [state, setState] = useState({
        oldValue: value?.toString(),
        currentValue: rawValue ? rawValue : '',
        passwordShow: false,
        isSelectSuggest: false,
        isTyping: false,
        typingTimer: 1000,
        suggestionElement: undefined,
        suggestionInputElement: undefined,
    });

    const handleOnChange = (eventValue) => {
        let isValidValue = true;

        if (isValidValue && onChange) {
            setState((prevState) => ({
                ...prevState,
                oldValue: eventValue,
            }));

            onChange(eventValue);
        }
    };

    const handleOutFocus = (eventValue) => {
        let isValidValue = true;

        if (isValidValue && onBlur) {
            setState((prevState) => ({
                ...prevState,
                oldValue: eventValue,
            }));

            onBlur(eventValue);
        }
    };

    const handleOnKeyUp = (eventValue) => {
        let isValidValue = true;

        if (isValidValue && onKeyUp) {
            setState((prevState) => ({
                ...prevState,
                oldValue: eventValue,
            }));

            onKeyUp(eventValue);
        }
    };

    if (type === 'select') {
        return (
            <input
                autoComplete={autoComplete}
                id={id}
                disabled={disabled}
                className={`form-control form-control--input ${className ? className : ''}`}
                style={{ ...style }}
                onBlur={(event) => handleOutFocus(event.target.value)}
                onInput={(event) => handleOnChange(event.target.value)}
                onClick={(event) => (onClick ? onClick(event) : {})}
                onFocus={(event) => (onFocus ? onFocus(event) : {})}
                placeholder={placeholder}
                value={value}
                maxLength={maxLength}
                readOnly={readOnly}
                data-rum-ignore={dataRumIgnore}
            />
        );
    }

    if (type === 'textarea') {
        return (
            <textarea
                id={id}
                name={name}
                disabled={disabled}
                value={value}
                className={`form-control ${fontSize} ${className}`}
                onInput={(event) => handleOnChange(event.target.value)}
                onBlur={(event) => handleOutFocus(event.target.value)}
                onClick={(event) => (onClick ? onClick(event) : {})}
                autoComplete="off"
                placeholder={placeholder}
                maxLength={maxLength}
                data-rum-ignore={dataRumIgnore}
            />
        );
    }

    return (
        <input
            type={type}
            id={id}
            disabled={disabled}
            className={`form-control form-control--input ${className}`}
            onBlur={(event) => handleOutFocus(event.target.value)}
            onInput={(event) => handleOnChange(event.target.value)}
            onKeyDown={(event) => {
                handleOutFocus(event.target.value);
                let checkIfNum = false;
                if (event.key !== undefined && type === 'number') {
                    checkIfNum = event.key === 'e' || event.key === '.' || event.key === '+' || event.key === '-';
                }
                return checkIfNum && event.preventDefault();
            }}
            onKeyUp={(event) => handleOnKeyUp(event.target.value)}
            onClick={(event) => (onClick ? onClick(event) : {})}
            onKeyPress={(event) => (onPress ? onPress(event) : {})}
            onFocus={(event) => (onFocus ? onFocus(event) : {})}
            autoComplete={autoComplete}
            placeholder={placeholder}
            value={value}
            maxLength={maxLength}
            readOnly={readOnly}
            style={{ ...style }}
            data-rum-ignore={dataRumIgnore}
        />
    );
};

export default Input;
